import ExcelJS from "exceljs";
import { QUARTERS } from "../const";
import { calculatesAverageValue, getDateAsString } from "./utils";
import { QuarterDictionary, DirectionsRequirement, UniversalObject, Block, Department, RequirementDirection } from "../types/data";

export const exportExcelSummary = async (
  data: DirectionsRequirement[],
  params: {
    year: number;
    group: UniversalObject;
    factory: UniversalObject;
    gop: UniversalObject;
  },
) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("gop-summary");

  worksheet.getRow(1).font = {
    bold: true,
  };

  const quarterNames = QUARTERS.map((quarter) => `${QuarterDictionary[quarter]} кв.`);
  const facts = ['Все GOP', 'Фокусные GOP'];

  worksheet.columns = [
    { header: 'Год', key: 'Год', width: 10 },
    { header: 'Группа', key: 'Группа', width: 15 },
    { header: 'Завод', key: 'Завод', width: 20 },
    { header: 'GOP', key: 'GOP', width: 10 },
    { header: 'Направление', key: 'Направление', width: 15 },
    { header: 'Факт', key: 'Факт', width: 30 },
    ...quarterNames.map((quarter) => ({ header: quarter, key: quarter, width: 10 })),
  ];

  // Заполняем строки
  data.forEach((item) => {
    facts.forEach((fact) => {
      worksheet.addRow([
        params.year,
        params.group.name,
        params.factory.name,
        params.gop.name,
        item.title,
        fact,
        ...item.quarters.map((el) => {
          if (el.blockRequirements === null) return '';

          const isFocus = fact === 'Фокусные GOP';
          const value = isFocus
            ? calculatesAverageValue(el.blockRequirements, undefined, true, true)
            : calculatesAverageValue(el.blockRequirements, undefined, true);

          return value !== 'N/A' ? value + '%' : '';
        }),
      ]);
    });
});

  // Создание файла и скачивание
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `Сводка_${params.factory.name}_${params.gop.name}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export const exportExcelMain = async (
  data: Block[],
  departments: Department[],
  params: { factory: UniversalObject, gop: UniversalObject, direction: UniversalObject}
) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(`${params.direction.Title}`);

  worksheet.getRow(1).font = {
    bold: true,
  };

  worksheet.columns = [
    { header: 'Завод', key: 'Завод', width: 20 },
    { header: 'GOP', key: 'GOP', width: 10 },
    { header: 'Направление', key: 'Направление', width: 15 },
    { header: 'Блок', key: 'Блок', width: 20 },
    { header: 'Требование', key: 'Требование', width: 40 },
    { header: 'Фокусный', key: 'Фокусный', width: 10 },
    { header: 'Документация', key: 'Документация', width: 50 },
    ...departments.map((department) => ({ header: department.title, key: department.title, width: 10 })),
    { header: 'Среднее по заводу', key: 'Среднее по заводу', width: 25 },
  ];

  worksheet.addRow([
    params.factory.name,
    params.gop.name,
    params.direction.Title,
    'Общая оценка',
    '',
    '',
    '',
    ...departments.map((el) => {
      const value = calculatesAverageValue(data, el.title)

      return value !== 'N/A' ? value + '%' : '';
    }),
    calculatesAverageValue(data, undefined, true) !== 'N/A'
      ? calculatesAverageValue(data, undefined, true) + '%'
      : '',
  ])

  worksheet.getRow(2).font = { bold: true };

  data.forEach((item) => {
    worksheet.addRow([
      params.factory.name,
      params.gop.name,
      params.direction.Title,
      item.title,
      '',
      '',
      '',
      ...departments.map((el) => {
        const value = calculatesAverageValue(item.groupRequirements, el.title)

        return value !== 'N/A' ? value + '%' : '';
      }),
      calculatesAverageValue(item.groupRequirements, undefined, true) !== 'N/A'
        ? calculatesAverageValue(item.groupRequirements, undefined, true) + '%'
        : '',
    ])

    item.groupRequirements.forEach((requirement) => {
      worksheet.addRow([
        params.factory.name,
        params.gop.name,
        params.direction.Title,
        item.title,
        requirement.title,
        requirement.isFocal ? 'Да' : 'Нет',
        requirement.documentation ? requirement.documentation.text : '',
        ...requirement.answers.map((el) => el.answer),
        calculatesAverageValue(requirement.answers) !== 'N/A'
          ? calculatesAverageValue(requirement.answers) + '%'
          : '',
      ])
    })
  })

  // Создание файла и скачивание
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${params.factory.name}_${params.gop.name}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export const exportExcelFactory = async (data: RequirementDirection[], departments: Department[]) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("gop-report");

  worksheet.getRow(1).font = {
    bold: true,
  };

  worksheet.columns = [
    { header: 'Год', key: 'Год', width: 20 },
    { header: 'Квартал', key: 'Квартал', width: 10 },
    { header: 'Завод', key: 'Завод', width: 15 },
    { header: 'GOP', key: 'GOP', width: 20 },
    { header: 'Направление', key: 'Направление', width: 40 },
    { header: 'Блок', key: 'Блок', width: 20 },
    { header: 'Требование', key: 'Требование', width: 40 },
    { header: 'Фокусный', key: 'Фокусный', width: 10 },
    { header: 'Дополнительная информация', key: 'Дополнительная информация', width: 50 },
    ...departments.map((department) => ({ header: department.title, key: department.title, width: 10 })),
    { header: 'Среднее по заводу', key: 'Среднее по заводу', width: 25 },
    { header: 'Кто завершил оценку', key: 'Кто завершил оценку', width: 25 },
    { header: 'Дата завершения', key: 'Дата завершения', width: 25 },
  ];

  data.forEach((direction) => {
    worksheet.addRow([
      direction.year,
      `${QuarterDictionary[direction.quarter]} кв.`,
      direction.factory,
      direction.title,
      direction.direction.title,
      'Общая оценка',
      '',
      '',
      '',
      ...departments.map((el) => {
        const value = calculatesAverageValue(direction.direction.blockRequirements, el.title)

        return Number.isInteger(value) ? value + '%' : '';
      }),
      calculatesAverageValue(direction.direction.blockRequirements, undefined, true) !== 'N/A'
        ? calculatesAverageValue(direction.direction.blockRequirements, undefined, true) + '%'
        : '',
      direction.completedAssessment,
      getDateAsString(direction.completionDate as string)
    ])

    direction.direction.blockRequirements.forEach((block) => {
      worksheet.addRow([
        direction.year,
        `${QuarterDictionary[direction.quarter]} кв.`,
        direction.factory,
        direction.title,
        direction.direction.title,
        block.title,
        '',
        '',
        '',
        ...departments.map((el) => {
          const value = calculatesAverageValue(block.groupRequirements, el.title)

          return Number.isInteger(value) ? value + '%' : '';
        }),
        calculatesAverageValue(block.groupRequirements, undefined, true) !== 'N/A'
          ? calculatesAverageValue(block.groupRequirements, undefined, true) + '%'
          : '',
        direction.completedAssessment,
        getDateAsString(direction.completionDate as string)
      ])

      block.groupRequirements.forEach((requirement) => {
        const filterAnswers = requirement.answers.filter((item) => departments.includes(item.title));

        const answers = [
          ...filterAnswers.map((el) => el.answer),
          ...Array(Math.max(0, departments.length - filterAnswers.length)).fill('')
        ];

        worksheet.addRow([
          direction.year,
          `${QuarterDictionary[direction.quarter]} кв.`,
          direction.factory,
          direction.title,
          direction.direction.title,
          block.title,
          requirement.title,
          requirement.isFocal ? 'Да' : 'Нет',
          requirement.documentation ? requirement.documentation.text : '',
          ...answers,
          calculatesAverageValue(requirement.answers) !== 'N/A'
            ? calculatesAverageValue(requirement.answers) + '%'
            : '',
          direction.completedAssessment,
          getDateAsString(direction.completionDate as string)
        ])
      })
    })
  })

  // Создание файла и скачивание
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `Отчет.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
